const getCookieDomain = () => {
  return window.location.hostname.startsWith('localhost') ? 'localhost' : process.env.COOKIE_SDK_DOMAIN;
};

export default getCookieDomain;
